import jss from 'jss'
import preset from 'jss-preset-default'

// Additional styles
import 'ag-grid-community/dist/styles/ag-grid.css';
import 'ag-grid-community/dist/styles/ag-theme-blue.css';

jss.setup(preset());


// WEBPACK FOOTER //
// ./src/jss.js